<template>
	<div style="border: 1px solid #e2e7ed;padding: 5px;margin-bottom: 15px;">
		<el-form-item
				label="Dirección de la RME"
				prop="directionOfRME"
				:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
			<el-input v-model="requestForm.directionOfRME"
			          :disabled="onlyRead== true ? true: false"
			          placeholder="Dirección de la RME"/>
		</el-form-item>

		<el-form-item
				label="Coordenadas geográficas (en decimales)"
				prop="coordinatesOfRME"
				:rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
			<el-input v-model="requestForm.coordinatesOfRME"
			          :disabled="onlyRead== true ? true: false"
			          placeholder="Coordenadas geográficas (en decimales)"/>
		</el-form-item>


		<!-- documentos -->
		<Docs :onlyRead="onlyRead" :sectionId="8" :onlyOne="true">
			<div slot="main">
				Archivos de plano
			</div>
		</Docs>

		<Docs :onlyRead="onlyRead" :sectionId="9" :onlyOne="true">
			<div slot="main">
				Fotografías de bienes
			</div>
		</Docs>

	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
	import Docs from '@/components/views/acquisition/partials/Docs'

	export default {
		components: {
			Docs
		},
		computed: {
			...mapGetters("form", {
				requestForm: "requestForm",
				catalogs: "catalogs",
				general: "general",
				onlyRead: "onlyRead"
			}),
		},
	}
</script>

<style scoped>

</style>